// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormInputPassword_wrapper"};